// Product Page Mini Review Slider
document.addEventListener('DOMContentLoaded', function () {
  const swiperMini = new Swiper('.swiper.swiper-mini', {
  // Optional parameters
    loop: true,
    // Set different number of slides per view for different screen sizes
    breakpoints: {
      // when window width is >= 320px
      320: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 00, },
      480: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0, },
      640: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0, }
    },    
    autoplay: { delay: 2500, disableOnInteraction: false, },
    speed: 500, // Transition duration in milliseconds
    pagination: { el: '.swiper-pagination.swiper-mini', clickable: true },
    navigation: { nextEl: '.swiper-button-next.swiper-mini', prevEl: '.swiper-button-prev.swiper-mini', },
  });
});

// Sticky ATC Button
document.addEventListener("DOMContentLoaded", function() {
  const stickyButton = document.querySelector('.cai-sticky-atc .paymentButtonsWrapper');
  const placeholder = document.querySelector('.cai-sticky-atc .paymentButtonsWrapper-placeholder');
  if (!stickyButton || !placeholder) return;

  let isFixed = false; // Track the fixed state of the button
  const buttonHeight = stickyButton.offsetHeight;
  const buttonTop = stickyButton.getBoundingClientRect().top + window.scrollY;

  // Set the height of the placeholder element
  placeholder.style.height = `${buttonHeight}px`;

  // Throttle function to limit the rate of execution
  function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function() {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function() {
          if ((Date.now() - lastRan) >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    }
  }

  function checkScroll() {
    if (window.innerWidth <= 768) { // Check if it's a mobile device
      if (window.scrollY > buttonTop + buttonHeight && !isFixed) { // Check if the button is out of view and not already fixed
        stickyButton.classList.add('fixed');
        placeholder.style.display = 'block'; // Show the placeholder
        setTimeout(() => stickyButton.classList.add('show'), 300); // Add show class after fixed
        isFixed = true; // Update the fixed state
      } else if (window.scrollY <= buttonTop + buttonHeight && isFixed) { // Check if the button is back in view and currently fixed
        stickyButton.classList.remove('show'); // Remove show class first
        setTimeout(() => {
          stickyButton.classList.remove('fixed'); // Remove fixed class after the transition
          placeholder.style.display = 'none'; // Hide the placeholder
        }, 300);
        isFixed = false; // Update the fixed state
      }
    } else if (isFixed) { // Remove fixed class if it's not a mobile device
      stickyButton.classList.remove('show'); // Remove show class first
      setTimeout(() => {
        stickyButton.classList.remove('fixed'); // Remove fixed class after the transition
        placeholder.style.display = 'none'; // Hide the placeholder
      }, 300);
      isFixed = false; // Update the fixed state
    }
  }

  window.addEventListener('scroll', throttle(checkScroll, 100));
  window.addEventListener('resize', throttle(checkScroll, 100)); // Ensure it also works on resize
});